import {
  SET_CITIES
} from './mutationTypes'

export const mutations = {
  [SET_CITIES]: (state, payload) => state.cities = payload
}
